export default __webpack_public_path__ + "ac6ff01d37bc7b8dc9701f0d0f285080.jpg";